import React from 'react';
import { clearIconLarge, clearIconDisabledLarge, iconWrapperLarge, searchIconDisabledLarge, searchIconLarge, } from '../styles/legacy';
import { citrusStyled } from '@citrus/runtime';
var ClearIconLarge = citrusStyled.span('clearIconLarge', clearIconLarge);
var ClearIconDisabledLarge = citrusStyled.span('clearIconDisabledLarge', clearIconDisabledLarge);
var IconLarge = citrusStyled.span('searchIconLarge', searchIconLarge);
var IconDisabledLarge = citrusStyled.span('searchIconDisabledLarge', searchIconDisabledLarge);
var WrapperLarge = citrusStyled.div('iconWrapperLarge', iconWrapperLarge);
export var IconWrapper = function (_a) {
    var children = _a.children;
    return React.createElement(WrapperLarge, null, children);
};
export var SearchIcon = function (_a) {
    var disabled = _a.disabled;
    return (React.createElement(IconWrapper, null, renderIcon(disabled)));
};
var renderIcon = function (disabled) {
    if (disabled) {
        return React.createElement(IconDisabledLarge, null);
    }
    return React.createElement(IconLarge, null);
};
// Keep __TYPE for styling purposes
export var ClearSearchIcon = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.__TYPE, __TYPE = _c === void 0 ? 'Icon' : _c;
    if (disabled) {
        return React.createElement(ClearIconDisabledLarge, null);
    }
    return React.createElement(ClearIconLarge, null);
};
ClearSearchIcon.defaultProps = {
    __TYPE: 'Icon',
};
